module.exports = __webpack_public_path__ + "static/media/animated_pradum.f15fa779.png";